<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="container-fluid">
    <Breadcrumbs main="Emission Intensity" :path="breadcrumbPath" />

    <el-row class="m-0 width-100-p mt-3">
      <el-col class="d-flex align-item-center px-2" :span="24">
        <div class="row m-0 width-100-p px-2">
          <div
            class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
          >
            <el-row :gutter="$vuetify.display.width > 1200 ? 20 : 0">
              <!-- search bay -->
              <el-col
                    :span="$vuetify.display.width > 1200 ? 16 : 24"
                    :class="$vuetify.display.width > 1200 ? 'x-start order-1 mb-10' : 'x-start order-3 mb-10'"
                  >
                    <el-select
                      v-model="regionFilter"
                      placeholder="All regions"
                      clearable
                      filterable
                      size="large"
                      class="mb-10"
                      style="width: 100%"
                      @change="handleReload"
                      @clear="handleReload"
                    >
                      <el-option
                        v-for="item in regionList"
                        :key="item"
                        :label="item"
                        :value="item"
                      />
                    </el-select>
                    <el-input
                      size="large"
                      v-model="search"
                      :placeholder="'Type to search by region...'"
                      class="mixedSearchBar-2"
                      id="mixedSearchBar-input-2"
                      clearable
                      @clear="handleReload"
                    >
                      <template #append>
                        <!-- <el-button :icon="Search" /> -->
                        <el-button
                            @click.stop="handleReload"
                            class="newSearchButtonClass"
                          >
                          <svg v-if="$vuetify.display.width > 800" class="width-115 height-40">
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon"
                            ></use>
                          </svg>
                          <svg v-else class="width-59 height-40" >
                            <use
                              href="@/assets/svg/newSvgIcon.svg#newSearchButtonIcon-small"
                            ></use>
                          </svg>
                        </el-button>
                      </template>
                    </el-input>

              </el-col>

              <el-col
                    :class="$vuetify.display.width > 1200 ? 'd-flex justify-content-end order-2' : 'd-flex justify-content-end order-1 mb-20'"
                    :span="$vuetify.display.width > 1200 ? 8 : 24"
                  >
                  <el-button
                      v-if="
                          $store.state.auth.user != null &&
                          !$store.state.auth.user.is_auditor
                        "
                      @click.stop="handleNew"
                      class="newAddButtonNoText new-button-behavior x-end"
                      size="small"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newAddButtonNoText"></use>
                        </svg>
                    </el-button>
                    <el-button
                      @click.stop="handleExportFile"
                      class="new-download-file-btn new-button-behavior x-end"
                    >
                        <svg class="width-40 height-40">
                          <use href="@/assets/svg/newSvgIcon.svg#newDownloadFileIcon"></use>
                        </svg>
                    </el-button>
              </el-col>
            </el-row>

            <DataTable
              :loadingProp="loading"
              :emissionIntensityDataProp="displayTableData"
              :totalRowProp="total_items"
              @tableAction="handleTableAction"
            />
          </div>
        </div>
      </el-col>
    </el-row>

    <ShowDetail
      :open_modal="show_modal"
      :data_modal="data_modal"
      :copiedDataProp="copiedData"
      :regionList="regionList"
      :existingVersions="emissionIntensityList"
      @close_modal="close_modal"
      @confirm_modal="confirm_modal"
      @refresh="refresh"
    />


  </div>
</template>

<script>
import Breadcrumbs from "../../components/bread_crumbs.vue";
// import XLSX from "xlsx";
import UserService from "../../services/user.service";
import DataTable from "./dataTable.vue";
// import Filter from "./filter.vue";
import ShowDetail from "./dialogDetail.vue";
import { ElMessageBox } from "element-plus";
import { exportToExcel } from "../dashboard/common/exportExcel";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "emissionIntensities",
  components: {
    Breadcrumbs,
    ShowDetail,
    DataTable,
  },
  data() {
    return {
      breadcrumbPath: [
        {
          title: "Input",
          disabled: true,
          href: "",
        },
        {
          title: "Emission Intensity",
          disabled: false,
          href: "/factors/emission-intensity",
          active: true,
        },
      ],

      show: true,
      regionList: [],
      emissionIntensityList: [],
      beforeSearch: [],
      searchResult: [],
      displayTableData:[],
      search: "",
      regionFilter: "",
      current_page: 0,
      page_size: 50,
      total_items: 100,
      perPageCount: 50,


      loading: false,
      show_modal: false,
      data_modal: null,
      current_row_index: null,
      filterOpen: false,

      copiedData: null, // data copied from data table
    };
  },
  watch: {
    emissionIntensityList: {
      handler: "applySearch",
      immediate: true,
    },

    searchResult: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    current_page: {
      handler: "handlePaginatedData",
      immediate: true,
    },

    page_size: {
      handler: "handlePaginatedData",
      immediate: true,
    },
    // pagination and search
  },
  computed: {
    filterEmissionIntensity() {
      return this.emissionIntensityList;
    },

    // pagination for table data (by region so expand can show full history)
    paginatedData() {
      const groups = this.groupByRegion(this.searchResult);
      let start = (this.current_page - 1) * this.page_size;
      if (start < 0) {
        start = 0;
      }
      const end =
        start + this.page_size >= groups.length
          ? groups.length
          : start + this.page_size;
      return groups.slice(start, end).flatMap((group) => group.versions);
    },
  },
  mounted() {
    this.fetchEmissionIntensityData(1);
    this.fetchEmissionIntensityRegionList();
    this.copiedData = null; // reset copied data
  },
  methods: {
    handlePaginatedData() {
      this.displayTableData = this.paginatedData;
    },

    sortVersions(list) {
      return [...(list || [])].sort((a, b) => {
        const regionCmp = String(a.region_name || "").localeCompare(
          String(b.region_name || "")
        );
        if (regionCmp !== 0) {
          return regionCmp;
        }
        return String(b.start_date || "").localeCompare(String(a.start_date || ""));
      });
    },

    groupByRegion(list) {
      const groups = [];
      const indexByRegion = {};
      (list || []).forEach((item) => {
        const name = item.region_name;
        if (indexByRegion[name] == null) {
          indexByRegion[name] = groups.length;
          groups.push({ region_name: name, versions: [] });
        }
        groups[indexByRegion[name]].versions.push(item);
      });
      return groups;
    },

    applySearch() {
      let search = this.search;
      console.log("call search", search);

      let result = this.sortVersions(this.beforeSearch);
      if (this.regionFilter) {
        result = result.filter((item) => item.region_name === this.regionFilter);
      }
      if (search != "") {
        const term = search.toString().toLowerCase().trim();
        result = result.filter((item) => {
          return item.region_name?.toString().toLowerCase().includes(term)
        });
      }

      this.searchResult = result;
      this.total_items = this.groupByRegion(result).length;
    },

    async handleExportFile() {
      if (this.emissionIntensityList.length > 0) {
        const dataList = this.emissionIntensityList;
        const skipKeys = ["id", "created_at", "updated_at"];
        const fileName = "emissionIntensityList.xlsx";
        const newWorksheetName = "Emission Intensity";
        const title = "Emission Intensity List";
        try {
          await exportToExcel({
            dataList,
            skipKeys,
            fileName,
            newWorksheetName,
            title,
          });
        } catch (error) {
          console.log("error when export excel", error.message);
        }
      }
    },

    refresh () {
      this.fetchEmissionIntensityData(1);
    },

    fetchEmissionIntensityRegionList() {
      UserService.getEmissionIntensityRegionList()
        .then(response => {
          this.regionList = response.data;
        })
    },

    fetchEmissionIntensityData(page) {
      UserService.getEmissionIntensityList(null, null, page, this.perPageCount, true)
        .then(
          (response) => {
            const rows = Array.isArray(response.data)
              ? response.data
              : (response.data?.results || []);
            this.emissionIntensityList = this.sortVersions(rows);
            this.beforeSearch = [...this.emissionIntensityList];
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          }
        ).then(
          () => {
            this.current_page = 1;
            this.page_size = 50;
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          }
        })
        .finally(() => (this.loading = false));
    },
    // eslint-disable-next-line no-unused-vars
    handleRowClick(row, column, event) {
      // console.log(row, column, event);
    },
    // eslint-disable-next-line no-unused-vars
    close_modal(event) {
      this.show_modal = false;
    },

    confirm_modal(event) {
      console.log(event);
      this.show_modal = false;
    },

    handleShow(index, data) {
      this.current_row_index = index;
      this.data_modal = data;
      this.show_modal = true;
    },

    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },


    reset_filter(event) {
      this.current_page = 1;
      this.search = "";
      this.filter = event.filter;
    },

    handleTableAction(event) {
      if (event.kind == "edit") {
        this.handleShow(event.index, event.data);
      } else if (event.kind == "delete") {
        this.deleteRow(event.data, event.index);
      } else if (event.kind == "changePage") {
        this.current_page = event.index;
      } else if (event.kind == "copy") {
        this.handleNewVersion(event.data);
      }
      else if (event.kind == "perPageChange") {
        this.current_page = 1;
        this.page_size = event.index;
        this.perPageCount = event.index;
        this.handleReload();
      }
    },

    handleCopyRow(event) {
      // console.log(event, index);
      this.copiedData = event;
    },

    handleNewVersion(row) {
      this.copiedData = row;
      this.current_row_index = this.emissionIntensityList.length;
      this.data_modal = {
        id: null,
        region_name: row.region_name,
        name: "",
        factor: row.factor,
        start_date: "",
        end_date: null,
      };
      this.show_modal = true;
    },

    handleReload() {
      this.current_page = 1;
      this.applySearch();
    },
    handleNew() {
      let data = {
        id: null,
        region_name: "",
        name: "",
        factor: "",
        start_date: "",
        end_date: null,
      };
      this.current_row_index = this.emissionIntensityList.length;
      this.data_modal = data;
      this.show_modal = true;
    },
    filterSearch(event) {
      this.search = event.search;
    },
    deleteRow(event, index) {
      console.log(event, index);
      ElMessageBox.confirm("Are you sure to delete this?", "info", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "Confirm Delete",
      })
        .then(() => {
          this.deleteFactor(event, index);
        })
        .catch(() => {
          // ElMessage({
          //   type: "info",
          //   message: "Delete canceled",
          // });
        });
    },
    deleteFactor(data) {
      UserService.deleteEmissionIntensity(data.id)
        .then(
          // eslint-disable-next-line no-unused-vars
          (response) => {
            this.refresh();
          },
          (error) => {
            this.loading = false;
            console.log(error);
            if (error.response && error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            } else if (error.response) {
              const apiData = error.response.data;
              const message =
                (typeof apiData === "string" && apiData) ||
                apiData?.detail ||
                (Array.isArray(apiData?.non_field_errors) &&
                  apiData.non_field_errors.join(" ")) ||
                "Unable to delete emission intensity";
              this.$message.error(message);
            }
          }
        )
        .catch((error) => {
          this.loading = false;
          console.log(error);
          if (error.response && error.response.status == 401) {
            this.$router.push({
              path: "/",
            });
          } else if (error.response) {
            const apiData = error.response.data;
            const message =
              (typeof apiData === "string" && apiData) ||
              apiData?.detail ||
              (Array.isArray(apiData?.non_field_errors) &&
                apiData.non_field_errors.join(" ")) ||
              "Unable to delete emission intensity";
            this.$message.error(message);
          }
        })
        .finally(() => (
          
          this.loading = false));
    },
  },
};
</script>

<style>
.el-table .warning-row {
  --el-table-tr-bg-color: var(--el-color-warning-light-8);
}
.el-table .error-row {
  --el-table-tr-bg-color: var(--el-color-error-light-8);
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.cell {
  text-align: center !important;
}

.starter-main .card-body ul {
  list-style-type: none !important;
}

.el-pager {
  -webkit-user-select: none !important;
  user-select: none !important;
  list-style: none !important;
  font-size: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  display: flex !important;
  align-items: center !important;
  position: relative !important;
  top: 0 !important;
  right: 0 !important;
}

.el-upload-list {
  margin: 10px 0 0 !important;
  padding: 0 !important;
  list-style: none !important;
  position: relative !important;
}
</style>
